import { Fragment, FunctionComponent, lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

const SendAttachment = lazy(
  () =>
    import(
      '@/modules/Attachment/submodules/MedicalAttachment/pages/SendAttachment/SendAttachment.component'
    ),
)

const DocumentList = lazy(
  () => import('@/modules/Attachment/submodules/Documents/pages/DocumentList'),
)

const DocumentHistory = lazy(
  () =>
    import('@/modules/Attachment/submodules/Documents/pages/DocumentHistory'),
)

const DocumentDetails = lazy(
  () =>
    import('@/modules/Attachment/submodules/Documents/pages/DocumentDetails'),
)

const ConfirmationSending = lazy(
  () =>
    import(
      '@/modules/Attachment/submodules/MedicalAttachment/pages/ConfirmationSending/ConfirmationSending.component'
    ),
)

const routes = [
  <Route path="/documentos" key="/documentos" exact component={DocumentList} />,
  <Route
    path="/documentos/historico/:documentId"
    key="/documentos/historico/:documentId"
    exact
    component={DocumentHistory}
  />,
  <Route
    path="/documentos/detalhes/:documentId"
    key="/documentos/detalhes/:documentId"
    exact
    component={DocumentDetails}
  />,
  <Route
    path="/documentos/encaminhamento-medico/anexar"
    key="/documentos/encaminhamento-medico/anexar"
    exact
    component={SendAttachment}
  />,
  <Route
    path="/documentos/encaminhamento-medico/enviado-com-sucesso/:documentId"
    key="/documentos/encaminhamento-medico/enviado-com-sucesso/:documentId"
    exact
    component={ConfirmationSending}
  />,
]

const AttachmentRoutes: FunctionComponent = () => (
  <Fragment>
    <Switch>{routes}</Switch>
  </Fragment>
)

export default AttachmentRoutes
